(function () {
    UX.noFocusableSVG = {
        init: function () {
            if (UX.test.isIE) {
                const svgs = document.getElementsByTagName('svg');
                let i = svgs.length;
                while (i--) {
                    svgs[i].setAttribute('focusable', false);
                }
            }
        },
    };
})();
